import React, { useState, useEffect } from 'react'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'

const MudikCarousel: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0)

  // Data dummy banner
  const banners = [
    { id: 1, src: '/img/img-banner-1.png', alt: 'Banner 1' },
    { id: 3, src: '/img/img-banner-2.png', alt: 'Banner 3' },
    { id: 2, src: '/img/img-banner-3.png', alt: 'Banner 2' },
  ]

  // Logika Auto-play
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex === banners.length - 1 ? 0 : prevIndex + 1))
    }, 5000)

    return () => clearInterval(interval)
  }, [banners.length])

  return (
    <div className='mt-5 px-4'>
      {/* Container Slide */}
      <div className='position-relative overflow-hidden rounded-4 shadow-sm mb-3' style={{ height: 'auto' }}>
        <div 
          className='d-flex transition-all duration-500 ease-in-out'
          style={{ 
            transform: `translateX(-${activeIndex * 100}%)`,
            transition: 'transform 0.6s ease-in-out'
          }}
        >
          {banners.map((banner) => (
            <div key={banner.id} className='w-100 flex-shrink-0'>
              <img
                src={toAbsoluteUrl(banner.src)}
                alt={banner.alt}
                className='w-100'
                style={{ objectFit: 'cover', display: 'block' }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Indikator Carousel */}
      <div className='d-flex justify-content-center gap-2 mb-4'>
        {banners.map((_, index) => (
          <div
            key={index}
            onClick={() => setActiveIndex(index)} // Bisa diklik manual
            style={{
              width: index === activeIndex ? '24px' : '8px', // Efek memanjang jika aktif
              height: '8px',
              borderRadius: '10px',
              backgroundColor: index === activeIndex ? '#72BF44' : '#D9D9D9',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
          ></div>
        ))}
      </div>
    </div>
  )
}

export default MudikCarousel